  /**
   * get quantity with operator plus or minus
   */
  export const getQtyOperator = (qty: number) =>
    qty > 0 ? `+` : "";
